import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Calendar, ArrowRight } from 'lucide-react';

const CARD_INITIAL = { opacity: 0, y: 30 };
const CARD_VISIBLE = { opacity: 1, y: 0 };
const CARD_HOVER = { y: -10 };

const BlogPostCard = ({ post, index, isInView, readMoreLabel }) => {
  const transition = { delay: index * 0.1, duration: 0.6 };

  return (
    <motion.article
      initial={CARD_INITIAL}
      animate={isInView ? CARD_VISIBLE : CARD_INITIAL}
      transition={transition}
      whileHover={CARD_HOVER}
      className="group relative"
    >
      <Link to={`/blog/${post.id}`} className="block">
        <div className="relative h-full rounded-2xl bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm border border-white/10 hover:border-white/20 transition-all duration-300 overflow-hidden">
          {/* Image */}
          <div className="relative h-48 overflow-hidden">
            <img
              src={post.image}
              alt={post.title}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900 to-transparent" />
          </div>

          {/* Content */}
          <div className="p-6">
            <div className="flex items-center gap-4 text-sm text-gray-400 mb-3">
              <div className="flex items-center space-x-1">
                <Calendar className="w-4 h-4" />
                <span>{post.date}</span>
              </div>
            </div>

            <div className="inline-block px-3 py-1 rounded-full bg-orange-500/10 border border-orange-500/20 mb-3">
              <span className="text-orange-300 text-xs font-medium">{post.category}</span>
            </div>

            <h3 className="text-xl font-bold text-white mb-3 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:bg-clip-text group-hover:from-blue-400 group-hover:to-purple-400 transition-all">
              {post.title}
            </h3>

            <p className="text-gray-400 mb-4 line-clamp-2">
              {post.excerpt}
            </p>

            <div className="flex items-center space-x-2 text-orange-400 hover:text-orange-300 font-medium group/btn">
              <span>{readMoreLabel}</span>
              <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
            </div>
          </div>
        </div>
      </Link>
    </motion.article>
  );
};

export default BlogPostCard;
